$('.insta-slider').slick({
  dots: false,
  infinite: true,
  centerMode: true,
  centerPadding: '60px',
  arrows: false,
  autoplay: true,
  autoplaySpeed: 1000,
  speed: 600,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
         centerPadding: '40px',
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.review-slider').slick({
  dots: false,
  infinite: true,
  centerMode: true,
  centerPadding: '60px',
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
         centerPadding: '40px',
          dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$('.video-slider').slick({
  dots: false,
  infinite: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
         centerMode: true,
         centerPadding: '40px',
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});


$('.flavors-slider').slick({
  dots: false,
  infinite: true,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1270,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 980,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$(".circle_percent").each(function() {
    var $this = $(this),
		$dataV = $this.data("percent"),
		$dataDeg = $dataV * 3.6,
		$round = $this.find(".round_per");
	$round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");	
	$this.append('<div class="circle_inbox"><span class="percent_text"></span></div>');
	$this.prop('Counter', 0).animate({Counter: $dataV},
	{
		duration: 2000, 
		easing: 'swing', 
		step: function (now) {
            $this.find(".percent_text").text(Math.ceil(now)+"%");
        }
    });
	if($dataV >= 51){
		$round.css("transform", "rotate(" + 360 + "deg)");
		setTimeout(function(){
			$this.addClass("percent_more");
		},1000);
		setTimeout(function(){
			$round.css("transform", "rotate(" + parseInt($dataDeg + 180) + "deg)");
		},1000);
	} 
});



$(document).ready(function() {
   $('a[href^="#"]').on('click', function(event) {
      var target = $(this.getAttribute('href'));
      if (target.length) {
         event.preventDefault();
         $('html, body').stop().animate({
            scrollTop: target.offset().top
         }, 1000);
      }
   });
});

(function() {
  var cartCrossSellWidgets = [];
  var scheduledCarouselRefreshes = new WeakMap();
  var carouselRefreshDelays = [0, 100, 300, 700];

  function getWidgetElement(widget) {
    return widget && (widget.el || widget.element);
  }

  function isCartCrossSell(widget) {
    var widgetElement = getWidgetElement(widget);

    return Boolean(
      widgetElement &&
      widgetElement.closest('#rebuy-cart [data-rebuy-component="cross-sell-widget"]')
    );
  }

  function configureCartCrossSell(widget) {
    if (!isCartCrossSell(widget)) {
      return null;
    }

    var widgetElement = getWidgetElement(widget);
    var layout = widget.data && widget.data.settings && widget.data.settings.layout;

    if (layout) {
      ['small', 'medium', 'large'].forEach(function(screenSize) {
        if (layout[screenSize] && layout[screenSize].carousel) {
          layout[screenSize].columns = 1;
        }
      });
    }

    var productGrid = widgetElement.querySelector('.rebuy-product-grid.splide');
    var carousel = widget.View && widget.View.carousel;

    if (productGrid && carousel && carousel.options) {
      var breakpoints = Object.assign({}, carousel.options.breakpoints);

      Object.keys(breakpoints).forEach(function(breakpoint) {
        breakpoints[breakpoint] = Object.assign({}, breakpoints[breakpoint], {
          arrows: true,
          omitEnd: false,
          perPage: 1,
          rewind: true
        });
      });

      carousel.options = {
        arrows: true,
        omitEnd: false,
        perPage: 1,
        breakpoints: breakpoints,
        rewind: true
      };
    }

    return carousel || null;
  }

  function rememberCartCrossSell(widget) {
    if (cartCrossSellWidgets.indexOf(widget) === -1) {
      cartCrossSellWidgets.push(widget);
    }
  }

  function refreshCartCrossSell(widget) {
    var widgetElement = getWidgetElement(widget);

    if (!isCartCrossSell(widget) || !widgetElement.isConnected) {
      return;
    }

    var carousel = configureCartCrossSell(widget);

    if (carousel && typeof carousel.refresh === 'function') {
      carousel.refresh();
    }
  }

  function scheduleCartCrossSellRefresh(widget) {
    if (!isCartCrossSell(widget)) {
      return;
    }

    rememberCartCrossSell(widget);
    configureCartCrossSell(widget);

    var scheduledTimers = scheduledCarouselRefreshes.get(widget) || [];

    scheduledTimers.forEach(function(timer) {
      window.clearTimeout(timer);
    });

    scheduledCarouselRefreshes.set(widget, carouselRefreshDelays.map(function(delay) {
      return window.setTimeout(function() {
        window.requestAnimationFrame(function() {
          refreshCartCrossSell(widget);
        });
      }, delay);
    }));
  }

  function scheduleTrackedCartCrossSells() {
    var currentWidgets = window.Rebuy && Array.isArray(window.Rebuy.widgets) ? window.Rebuy.widgets : [];

    currentWidgets.forEach(function(widget) {
      if (cartCrossSellWidgets.indexOf(widget) === -1) {
        cartCrossSellWidgets.push(widget);
      }
    });

    cartCrossSellWidgets = cartCrossSellWidgets.filter(function(widget) {
      var widgetElement = getWidgetElement(widget);

      return isCartCrossSell(widget) && widgetElement.isConnected;
    });

    cartCrossSellWidgets.forEach(scheduleCartCrossSellRefresh);
  }

  document.addEventListener('rebuy.init', function(event) {
    scheduleCartCrossSellRefresh(event.detail && event.detail.widget);
  });

  document.addEventListener('rebuy.beforeReady', function(event) {
    scheduleCartCrossSellRefresh(event.detail && event.detail.widget);
  });

  document.addEventListener('rebuy.ready', function(event) {
    scheduleCartCrossSellRefresh(event.detail && event.detail.widget);
  });

  document.addEventListener('rebuy.productsChange', function(event) {
    scheduleCartCrossSellRefresh(event.detail && event.detail.widget);
  });

  document.addEventListener('rebuy.beforeProductsChange', function(event) {
    scheduleCartCrossSellRefresh(event.detail && event.detail.widget);
  });

  document.addEventListener('rebuy.refresh', function(event) {
    scheduleCartCrossSellRefresh(event.detail && event.detail.widget);
  });

  document.addEventListener('rebuy:cart.change', scheduleTrackedCartCrossSells);
})();

(function() {
  var bottleDiscountSettings = {
    productHandle: '',
    code3: '',
    code5: ''
  };
  var latestCart = null;

  function setBottleDiscountSettings(settings) {
    if (!settings) {
      return bottleDiscountSettings;
    }

    bottleDiscountSettings.productHandle = (settings.productHandle || bottleDiscountSettings.productHandle || '').toLowerCase();
    bottleDiscountSettings.code3 = settings.code3 || bottleDiscountSettings.code3 || '';
    bottleDiscountSettings.code5 = settings.code5 || bottleDiscountSettings.code5 || '';
    return bottleDiscountSettings;
  }

  function setBottleDiscountSettingsFromCart(cart) {
    var attributes = cart && cart.attributes ? cart.attributes : {};

    latestCart = cart || latestCart;
    return setBottleDiscountSettings({
      productHandle: attributes._shroomsoda_bottle_discount_product_handle,
      code3: attributes._shroomsoda_bottle_discount_code_3,
      code5: attributes._shroomsoda_bottle_discount_code_5
    });
  }

  function fetchCart() {
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) {
        throw new Error('Unable to load cart');
      }

      return response.json();
    }).then(function(cart) {
      setBottleDiscountSettingsFromCart(cart);
      return cart;
    });
  }

  setBottleDiscountSettings(window.ANANDA_BOTTLE_DISCOUNT_SETTINGS);
  fetchCart().catch(function() {});

  function getDiscountCode(itemElement) {
    var message = itemElement.querySelector(':scope > .rebuy-cart__flyout-item-info > .rebuy-cart__flyout-item-discount-message');
    var messageText = message ? message.textContent.trim() : '';

    setBottleDiscountSettings(window.ANANDA_BOTTLE_DISCOUNT_SETTINGS);

    return [bottleDiscountSettings.code3, bottleDiscountSettings.code5].find(function(code) {
      return code && messageText.toLowerCase().indexOf(code.toLowerCase()) !== -1;
    }) || messageText;
  }

  function getItemQuantity(itemElement) {
    var input = itemElement.querySelector(':scope > .rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-quantity-widget-input');
    var label = itemElement.querySelector(':scope > .rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-quantity-widget-label');
    var quantityText = input ? input.value : (label ? label.textContent : '');
    var quantityMatch = quantityText.match(/([0-9]+)\s*$/);
    var quantity = quantityMatch ? parseInt(quantityMatch[1], 10) : 1;

    return Number.isFinite(quantity) ? quantity : 1;
  }

  function isWholesaleCustomer() {
    return document.documentElement.classList.contains('b2b-customer') || window.ANANDA_B2B_CUSTOMER === true;
  }

  function getSmartCartItem(itemElement) {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (!itemElement || !smartCart || typeof smartCart.items !== 'function') {
      return null;
    }

    var items = smartCart.items() || [];
    var nodes = Array.prototype.slice.call(document.querySelectorAll('#rebuy-cart [data-rebuy-component="cart-items"] .rebuy-cart__flyout-item'));
    var index = nodes.indexOf(itemElement);
    var title = ((itemElement.querySelector('.rebuy-cart__flyout-item-product-title') || {}).textContent || '').trim();
    var variant = ((itemElement.querySelector('.rebuy-cart__flyout-item-variant-title') || {}).textContent || '').trim();

    function matches(item) {
      var itemTitle = ((item && (item.product_title || item.title)) || '').trim();
      var itemVariant = ((item && item.variant_title) || '').trim();
      var handle = (item && item.handle) || '';

      if (title && itemTitle && title !== itemTitle) return false;
      if (variant && itemVariant && itemVariant !== 'Default Title' && variant !== itemVariant) return false;
      if (handle && !itemElement.classList.contains('product-' + handle)) return false;
      return true;
    }

    if (index > -1 && items[index] && matches(items[index])) return items[index];

    var matched = items.filter(matches);
    if (matched.length === 1) return matched[0];
    return index > -1 ? items[index] || null : null;
  }

  function wholesaleQtyRules(itemElement, item) {
    var title = ((itemElement.querySelector('.rebuy-cart__flyout-item-product-title') || {}).textContent || '').trim();
    if (!title && item) title = item.product_title || item.title || '';

    var properties = item && item.properties ? item.properties : {};
    if (properties._b2b_free_sample_for) {
      return { step: 1, min: 1 };
    }

    if (typeof window.anandaIsBackbarProductTitle === 'function' && window.anandaIsBackbarProductTitle(title)) {
      return { step: 1, min: 1 };
    }

    if (/backbar/i.test(title)) {
      return { step: 1, min: 1 };
    }

    return { step: 4, min: 4 };
  }

  function steppedQuantity(current, increasing, rules) {
    var quantity = parseInt(current, 10) || 0;

    if (increasing) {
      return quantity < rules.min ? rules.min : quantity + rules.step;
    }

    var next = quantity - rules.step;
    return next < rules.min ? 0 : next;
  }

  function applyWholesaleQuantity(itemElement, increasing) {
    var cartApi = window.Rebuy && window.Rebuy.Cart;
    var item = getSmartCartItem(itemElement);

    if (!item || !item.key || !cartApi || typeof cartApi.changeItem !== 'function') {
      return false;
    }

    var rules = wholesaleQtyRules(itemElement, item);
    if (!(rules.step > 1)) {
      return false;
    }

    // SmartCart.setItemQuantity clamps to the sidecart maximum of 10.
    if (item.status && item.status !== 'ready') {
      return true;
    }

    cartApi.changeItem({
      id: item.key,
      quantity: steppedQuantity(item.quantity, increasing, rules)
    });
    return true;
  }

  function getQuantityReduction(itemElement, removeButton) {
    if (removeButton) {
      return getItemQuantity(itemElement);
    }

    if (isWholesaleCustomer()) {
      var rules = wholesaleQtyRules(itemElement, getSmartCartItem(itemElement));
      if (rules.step > 1) return rules.step;
    }

    var input = itemElement.querySelector(':scope > .rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-quantity-widget-input');
    var step = input ? parseInt(input.getAttribute('step'), 10) : 1;

    return Number.isFinite(step) && step > 0 ? step : 1;
  }

  function normalizeDiscountCode(code) {
    return (code || '').trim().toLowerCase();
  }

  function discountCodesMatch(firstCode, secondCode) {
    return Boolean(firstCode && secondCode && normalizeDiscountCode(firstCode) === normalizeDiscountCode(secondCode));
  }

  function itemMatchesBottleDiscount(item, productHandle) {
    if (!productHandle || !item || item.selling_plan_allocation != null) {
      return false;
    }

    var properties = item.properties || {};

    if (Object.prototype.hasOwnProperty.call(properties, 'Bundle') || properties._bottle_discount_excluded === 'true') {
      return false;
    }

    var handle = (item.handle || '').toLowerCase();
    var url = (item.url || '').toLowerCase();

    return handle === productHandle || url.indexOf('/products/' + productHandle) !== -1;
  }

  function getBottleCount(cart, settings) {
    return (cart.items || []).reduce(function(total, item) {
      return itemMatchesBottleDiscount(item, settings.productHandle) ? total + item.quantity : total;
    }, 0);
  }

  function getBottleDiscountCode(bottleCount, settings) {
    if (bottleCount >= 5 && settings.code5) {
      return settings.code5;
    }

    if (bottleCount >= 3 && settings.code3) {
      return settings.code3;
    }

    return '';
  }

  function itemElementMatchesBottleDiscount(itemElement, currentCode) {
    var itemCode = getDiscountCode(itemElement);

    return !isSubscriptionItem(itemElement) && discountCodesMatch(itemCode, currentCode);
  }

  function getBottleDiscountTransition(cart, itemElement, quantityReduction) {
    var settings = setBottleDiscountSettingsFromCart(cart);
    var currentBottleCount = getBottleCount(cart, settings);
    var currentCode = getBottleDiscountCode(currentBottleCount, settings);

    if (!currentCode || !itemElementMatchesBottleDiscount(itemElement, currentCode)) {
      return null;
    }

    var projectedBottleCount = Math.max(0, currentBottleCount - quantityReduction);
    var projectedCode = getBottleDiscountCode(projectedBottleCount, settings);

    if (discountCodesMatch(currentCode, projectedCode)) {
      return null;
    }

    return {
      currentCode: currentCode,
      projectedCode: projectedCode
    };
  }

  function isConfiguredBottleDiscountCode(code) {
    return discountCodesMatch(code, bottleDiscountSettings.code3) || discountCodesMatch(code, bottleDiscountSettings.code5);
  }

  function getDiscountPercent(button, itemElement) {
    var percent = parseFloat(button.dataset.discountPercent);

    if (Number.isFinite(percent) && percent > 0) {
      return Math.round(percent);
    }

    var badge = itemElement.querySelector(':scope > .rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-badge');
    var match = badge && badge.textContent.match(/([0-9]+(?:\.[0-9]+)?)\s*%/);

    return match ? Math.round(parseFloat(match[1])) : 0;
  }

  function isSubscriptionItem(itemElement) {
    return Boolean(itemElement.querySelector(':scope > .rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-subscription-status'));
  }

  function getDiscountLabel(itemElement, discountCode, discountPercent) {
    if (discountCode) {
      return discountPercent + '% ' + discountCode + ' discount';
    }

    if (isSubscriptionItem(itemElement)) {
      return discountPercent + '% subscription discount';
    }

    return discountPercent + '% discount';
  }

  function getConfirmationMessage(itemElement, discountCode, currentPercent, removesLineItem) {
    var removedDiscount = getDiscountLabel(itemElement, discountCode, currentPercent);
    var action = removesLineItem ? 'Removing this item' : 'Reducing this quantity';

    return action + ' removes the ' + removedDiscount + '.';
  }

  function isDecreaseQuantityButton(button) {
    var ariaLabel = (button.getAttribute('aria-label') || '').toLowerCase();
    var quantityWidget = button.closest('.rebuy-cart__flyout-item-quantity-widget');
    var firstQuantityButton = quantityWidget && quantityWidget.querySelector('.rebuy-cart__flyout-item-quantity-widget-button');

    return button === firstQuantityButton || ariaLabel.indexOf('decrease quantity') === 0 || Boolean(button.querySelector('.fa-minus, rebuy-icon[name="minus"]'));
  }

  function replayButtonClick(button) {
    button.dataset.confirmed = 'true';
    button.click();
    delete button.dataset.confirmed;
  }

  function finishQuantityAction(button) {
    if (button.dataset.wholesaleStep === '1') {
      delete button.dataset.wholesaleStep;
      var itemElement = button.closest('.rebuy-cart__flyout-item');
      if (itemElement && applyWholesaleQuantity(itemElement, !isDecreaseQuantityButton(button))) {
        return;
      }
    }

    replayButtonClick(button);
  }

  function openRemoveConfirmation(button, messageText, confirmButtonText) {
    var existingDialog = document.querySelector('.rebuy-remove-confirm');

    if (existingDialog) {
      existingDialog.close();
    }

    var dialog = document.createElement('dialog');
    var message = document.createElement('p');
    var confirmButton = document.createElement('button');
    var keepButton = document.createElement('button');

    dialog.className = 'rebuy-remove-confirm';
    dialog.setAttribute('aria-labelledby', 'rebuy-remove-confirm-message');
    message.id = 'rebuy-remove-confirm-message';
    message.className = 'rebuy-remove-confirm__message';
    message.textContent = messageText;
    confirmButton.className = 'rebuy-remove-confirm__remove';
    confirmButton.type = 'button';
    confirmButton.textContent = confirmButtonText;
    keepButton.className = 'rebuy-remove-confirm__keep';
    keepButton.type = 'button';
    keepButton.textContent = 'Keep it';
    dialog.append(message, confirmButton, keepButton);
    document.body.appendChild(dialog);

    dialog.addEventListener('close', function() {
      dialog.remove();
    }, { once: true });

    dialog.addEventListener('click', function(event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    keepButton.addEventListener('click', function() {
      dialog.close();
    });

    confirmButton.addEventListener('click', function() {
      dialog.close();
      finishQuantityAction(button);
    });

    dialog.showModal();
    confirmButton.focus();
  }

  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var removeButton = event.target.closest('#rebuy-cart .rebuy-cart__flyout-item-remove');
    var quantityButton = event.target.closest('#rebuy-cart .rebuy-cart__flyout-item-quantity-widget-button');
    var button = removeButton || quantityButton;

    if (!button) {
      return;
    }

    if (button.dataset.confirmed === 'true') {
      return;
    }

    if (button.dataset.discountCheck === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    var itemElement = button.closest('.rebuy-cart__flyout-item');

    if (!itemElement) {
      return;
    }

    if (quantityButton && !isDecreaseQuantityButton(quantityButton)) {
      if (isWholesaleCustomer() && applyWholesaleQuantity(itemElement, true)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }

    var discountButton = removeButton || itemElement.querySelector(':scope > .rebuy-cart__flyout-item-info > .rebuy-cart__flyout-item-remove');

    if (!discountButton || discountButton.dataset.hasDiscount !== 'true') {
      if (quantityButton && isWholesaleCustomer() && applyWholesaleQuantity(itemElement, false)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }

    var currentPercent = getDiscountPercent(discountButton, itemElement);

    if (!(currentPercent > 0)) {
      return;
    }

    var discountCode = getDiscountCode(itemElement);
    var quantityReduction = getQuantityReduction(itemElement, removeButton);
    if (quantityButton && isWholesaleCustomer() && quantityReduction > 1) {
      button.dataset.wholesaleStep = '1';
    }
    var removesLineItem = Boolean(removeButton) || !(getItemQuantity(itemElement) > quantityReduction);
    var confirmButtonText = removesLineItem ? 'Got it, remove' : 'Got it, update';

    event.preventDefault();
    event.stopImmediatePropagation();
    button.dataset.discountCheck = 'true';

    fetchCart()
      .catch(function() {
        return latestCart;
      })
      .then(function(cart) {
        delete button.dataset.discountCheck;

        var transition = cart ? getBottleDiscountTransition(cart, itemElement, quantityReduction) : null;

        if (transition) {
          openRemoveConfirmation(
            button,
            getConfirmationMessage(itemElement, transition.currentCode, currentPercent, removesLineItem),
            confirmButtonText
          );
          return;
        }

        if (removesLineItem && !isConfiguredBottleDiscountCode(discountCode)) {
          openRemoveConfirmation(
            button,
            getConfirmationMessage(itemElement, discountCode, currentPercent, true),
            confirmButtonText
          );
          return;
        }

        if (!cart && isConfiguredBottleDiscountCode(discountCode)) {
          openRemoveConfirmation(
            button,
            getConfirmationMessage(itemElement, discountCode, currentPercent, removesLineItem),
            confirmButtonText
          );
          return;
        }

        finishQuantityAction(button);
      })
      .catch(function() {
        delete button.dataset.discountCheck;
        finishQuantityAction(button);
      });
  }, true);
})();
